import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import lodashIsEmpty from 'lodash/isEmpty';

import useInfiniteScroll from '../../Components/ListInfiniteScroll/index.controller';
import { numberToArray } from '../../Helper';
import routeList, { ReservationNavigatorProps } from '../../Routes/list';
import { useGetOrdersQuery } from '../../RTK/api/orders';
import { OrderDetails } from '../../RTK/api/orders/types';
import { setOrderDetailsFilter } from '../../RTK/utility';
import { OrderTypes } from '../../RTK/api/types';
import constants from '../../Config/constants';

const useMyReservations = () => {
  const dispatch = useDispatch();
  const navigation = useNavigation<NavigationProp<ReservationNavigatorProps>>();
  const [keyword, setKeyword] = useState<string>('');
  const [type, setType] = useState<OrderTypes[]>(
    constants.MY_RESERVATION_TYPE_FILTER[0].value.split(',') as OrderTypes[],
  );
  const { data, isLoading } = useGetOrdersQuery({
    payload: {
      keyword,
      limit: 100,
      offset: 0,
      order_type: type,
      status: 'new',
    },
  });
  const {
    data: pastBookings,
    onMomentumScrollBegin,
    onReachedEnd,
  } = useInfiniteScroll<OrderDetails>({
    loaderCount: 3,
    queryParams: {
      keyword,
      order_type: type,
      status: 'completed',
    },
    useQuery: useGetOrdersQuery,
  });
  const activeBookings = useMemo(() => {
    if (isLoading) {
      return numberToArray(2).map(() => ({ loading: true }));
    }
    return data.result;
  }, [data?.result, isLoading]);

  const _onCardPress = (data: OrderDetails) => {
    dispatch(setOrderDetailsFilter(data.args));
    navigation.navigate(routeList.MY_RESERVATION_DETAILS, {
      id: data.id,
      reservation: lodashIsEmpty(data.event_details),
    });
  };

  return {
    activeBookings,
    pastBookings,
    onCardPress: _onCardPress,
    onMomentumScrollBegin,
    onReachedEnd,
    setKeyword,
    setType,
  };
};

export default useMyReservations;
